import { useEffect } from "react";
import { toast } from "sonner";

// How long each kind of message stays; the toast host pauses the timer while the pointer or focus is on it.
export const TOAST_MS = { success: 4000, warning: 8000, error: 8000, notification: 10000 };

/** Shows a page message ({ type: "success" | "warning" | "error", text }) in the shared toast host, then clears it. */
export default function Toast({ msg, onClose }) {
  useEffect(() => {
    if (!msg) return;
    const show = { success: toast.success, warning: toast.warning }[msg.type] ?? toast.error;
    show(msg.text, { duration: TOAST_MS[msg.type] ?? TOAST_MS.error });
    if (onClose) onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msg]);
  return null;
}
